import { toaster } from 'components/v2/toast';
import EpdCompiler from 'pages/v2/compiler/EpdCompiler';
import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import { useCheckReadEpdAccess, useEpdFormat } from 'services/api/queries';

import EpdWizard from './EpdWizard';

const WizardSelector: React.FunctionComponent = () => {
  const { id } = useParams<{ id: string }>();
  const epdFormatQuery = useEpdFormat(id);
  const userHasAccessToViewEpd = useCheckReadEpdAccess(id);
  let epdFormat = epdFormatQuery?.data;

  if (userHasAccessToViewEpd.isSuccess && userHasAccessToViewEpd.data === false) {
    toaster({ severity: 'error', summary: 'Access denied', details: 'You do not have permission to view this EPD.' });
    return <Redirect to={EpdRoutes.dashboard} />;
  }

  if (userHasAccessToViewEpd.isSuccess && epdFormat) {
    return epdFormat === 'compiler' ? <EpdCompiler /> : <EpdWizard />;
  }

  return null;
};

export default WizardSelector;
